import { render, staticRenderFns } from "./SingleProducts.vue?vue&type=template&id=2a46a2fe&scoped=true&"
import script from "./SingleProducts.vue?vue&type=script&lang=js&"
export * from "./SingleProducts.vue?vue&type=script&lang=js&"
import style0 from "./SingleProducts.vue?vue&type=style&index=0&id=2a46a2fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46a2fe",
  null
  
)

export default component.exports